module.exports = __webpack_public_path__ + "img/6330130.png";